import React, { useState } from 'react';
import { apiService } from '../../../services/ApiService';
import { toast } from 'react-hot-toast';
import './CompartilharObraModal.css';

const CompartilharObraModal = ({ isOpen, onClose, idObra, obraAtual }) => {
  const [formData, setFormData] = useState({
    email: '',
    permissoes: ['visualizar'] // Por padrão, apenas visualização
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePermissaoChange = (permissao) => {
    setFormData(prev => ({
      ...prev,
      permissoes: prev.permissoes.includes(permissao)
        ? prev.permissoes.filter(p => p !== permissao)
        : [...prev.permissoes, permissao]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await apiService.compartilharObra(
        idObra,
        formData.email.toLowerCase(),
        formData.permissoes
      );
      
      if (response.success) {
        toast.success('Obra compartilhada com sucesso!');
        onClose();
      } else {
        // Verificar se é um erro de usuário não encontrado
        if (response.error === 'Usuário não encontrado' || 
            response.message?.includes('não está cadastrado')) {
          toast.error(
            response.message || 'Este email não está cadastrado no sistema. Por favor, cadastre o usuário antes de compartilhar a obra.',
            {
              duration: 5000,
              style: {
                background: '#fff3f3',
                border: '1px solid #ffcdd2',
                color: '#d32f2f',
                padding: '16px',
                borderRadius: '4px',
                maxWidth: '500px'
              }
            }
          );
        } else {
          // Para outros tipos de erro
          toast.error(response.message || response.error || 'Erro ao compartilhar obra');
        }
      }
    } catch (error) {
      console.error('Erro:', error);
      toast.error(
        'Erro ao compartilhar obra. Por favor, tente novamente.',
        {
          duration: 5000,
          style: {
            background: '#fff3f3',
            border: '1px solid #ffcdd2',
            color: '#d32f2f',
            padding: '16px',
            borderRadius: '4px',
            maxWidth: '500px'
          }
        }
      );
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Compartilhar Obra</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email do Usuário:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="exemplo@empresa.com.br"
              required
              title="Digite o email do usuário que receberá acesso à obra"
            />
            <small className="input-help">O usuário precisa estar cadastrado no sistema</small>
          </div>
          
          <div className="form-group">
            <label>Permissões:</label>
            <div className="permissoes-grid">
              <label className="permissao-item">
                <input
                  type="checkbox"
                  checked={formData.permissoes.includes('visualizar')}
                  onChange={() => handlePermissaoChange('visualizar')}
                />
                Visualizar
              </label>
              <label className="permissao-item">
                <input
                  type="checkbox"
                  checked={formData.permissoes.includes('editar')}
                  onChange={() => handlePermissaoChange('editar')}
                />
                Editar
              </label>
              <label className="permissao-item">
                <input
                  type="checkbox"
                  checked={formData.permissoes.includes('comentar')}
                  onChange={() => handlePermissaoChange('comentar')}
                />
                Comentar
              </label>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-submit">
              Compartilhar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompartilharObraModal; 